<template>
  <v-app>
    <v-main class="pa-0">
      <div class="maintenance-shell">
        <header class="institutional-banner">
          <img
            src="@/assets/BUZONWEB.svg"
            alt="Poder Judicial del Estado de Jalisco - Oficialía de Partes Virtual"
          />
        </header>

        <main class="maintenance-content">
          <span class="decorative-orb orb-one"></span>
          <span class="decorative-orb orb-two"></span>
          <span class="decorative-orb orb-three"></span>

          <v-card class="maintenance-card" elevation="12">
            <div class="card-accent"></div>

            <div class="icon-wrap">
              <v-icon size="52" color="white">mdi-wrench</v-icon>
            </div>

            <div class="status-pill">
              <span class="status-dot"></span>
              Servicio temporalmente no disponible
            </div>

            <h1 class="maintenance-title">Sistema en mantenimiento</h1>

            <p class="maintenance-subtitle">
              {{ maintenance.message }}
            </p>

            <v-divider class="my-6"></v-divider>

            <!-- <p class="reload-note">
              <v-icon small class="mr-2">mdi-reload</v-icon>
              Cuando el servicio se restablezca, recarga esta página para continuar.
            </p> -->
          </v-card>
        </main>

        <footer class="maintenance-footer">
          © {{ currentYear }} Supremo Tribunal de Justicia del Estado de Jalisco
        </footer>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Maintenance",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },
  computed: {
    ...mapState(["maintenance"])
  }
};
</script>

<style scoped>
.maintenance-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(circle at 15% 20%, rgba(200, 162, 74, 0.18), transparent 28%),
    radial-gradient(circle at 85% 80%, rgba(45, 106, 79, 0.22), transparent 30%),
    linear-gradient(135deg, #081c30 0%, #123a5a 48%, #0b2238 100%);
  overflow: hidden;
  position: relative;
}

.institutional-banner {
  position: relative;
  z-index: 3;
  background: #ffffff;
  padding: 10px 24px;
  box-shadow: 0 8px 24px rgba(3, 16, 28, 0.28);
}

.institutional-banner img {
  display: block;
  width: 100%;
  max-width: 1400px;
  height: auto;
  margin: 0 auto;
}

.maintenance-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 20px;
  position: relative;
  z-index: 2;
}

.maintenance-card {
  width: 100%;
  max-width: 640px;
  border-radius: 24px !important;
  padding: 52px 48px 40px;
  text-align: center;
  background: rgba(255, 255, 255, 0.97) !important;
  box-shadow: 0 28px 70px rgba(2, 12, 24, 0.4) !important;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(12px);
}

.card-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #c8a24a 0%, #1f4e79 38%, #2d6a4f 68%, #8b1e2d 100%);
}

.icon-wrap {
  width: 96px;
  height: 96px;
  margin: 0 auto 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #1f4e79, #123a5a);
  box-shadow:
    0 16px 34px rgba(18, 58, 90, 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  animation: float 4s ease-in-out infinite;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 15px;
  margin-bottom: 18px;
  border-radius: 999px;
  background: #fff5d9;
  color: #8a6a18;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d9a514;
  box-shadow: 0 0 0 4px rgba(217, 165, 20, 0.18);
  animation: blink 1.8s ease-in-out infinite;
}

.maintenance-title {
  margin: 0 0 14px;
  color: #102a43;
  font-size: clamp(1.65rem, 3vw, 2.2rem);
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: -0.02em;
}

.maintenance-subtitle {
  max-width: 480px;
  margin: 0 auto;
  color: #52667a;
  font-size: 1.04rem;
  line-height: 1.65;
}

.reload-note {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 15px 18px;
  border: 1px solid #dbe7f3;
  border-radius: 14px;
  background: #f2f7fc;
  color: #123a5a;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.5;
}

.maintenance-footer {
  position: relative;
  z-index: 2;
  padding: 18px 20px 24px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 12px;
  text-align: center;
  letter-spacing: 0.02em;
}

.decorative-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  opacity: 0.55;
  pointer-events: none;
}

.orb-one {
  width: 260px;
  height: 260px;
  top: 12%;
  left: -90px;
  background: radial-gradient(circle, rgba(200, 162, 74, 0.32), transparent 68%);
}

.orb-two {
  width: 320px;
  height: 320px;
  right: -120px;
  bottom: 8%;
  background: radial-gradient(circle, rgba(45, 106, 79, 0.36), transparent 68%);
}

.orb-three {
  width: 180px;
  height: 180px;
  top: 8%;
  right: 12%;
  background: radial-gradient(circle, rgba(139, 30, 45, 0.22), transparent 70%);
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

@media (max-width: 600px) {
  .institutional-banner {
    padding: 8px 12px;
  }

  .maintenance-content {
    padding: 34px 16px;
  }

  .maintenance-card {
    padding: 40px 22px 32px;
    border-radius: 20px !important;
  }

  .icon-wrap {
    width: 82px;
    height: 82px;
  }

  .status-pill {
    font-size: 10px;
  }

  .maintenance-footer {
    font-size: 11px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .icon-wrap,
  .status-dot {
    animation: none;
  }
}
</style>
